import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

function ViewPropertyCards({ modal, toggle, props }) {
    const { panNumber, pocName, gst, noOfProperties, pocNumber, adharNumber, area, investorName, address, contact, email } = props;
    return (
        <>
            <Modal className='border-0 ViewPropertyCard' isOpen={modal} toggle={toggle} size="lg" centered>
                <div className='bg-base-color py-4 text-center border-radius-32-top'><span className='title-font-700 fs-36 text-base-white text-center'>Investor Details</span></div>
                <ModalBody className='bg-background-color px-5 py-5 d-flex justify-content-center align-items-center border-radius-32-bottom'>
                    <div className="row p-5">
                        <div className="col-12 text-center text-sm-start text-md-start text-lg-start text-xl-start  col-lg-4 col-md-4  col-sm-6 col-xl-6 mt-3">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4 py-2">Name: <span className='fs-3 base-font-400 '>{investorName}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4 py-2">PAN: <span className='fs-3 base-font-400 '>{panNumber}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4 py-2">Contact: <span className='fs-3 base-font-400 '>{contact}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4 py-2">GST: <span className='fs-3 base-font-400 '>{gst}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4 py-2">No of Properties: <span className='fs-3 base-font-400 '>{noOfProperties}</span> </h5>
                               
                            </div>
                        </div>
                        <div className="col-12 text-center text-sm-start text-md-start text-lg-start text-xl-start  col-lg-4 col-md-4  col-sm-6 col-xl-6 mt-3">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4 py-2">Adhar:<span className='fs-3 base-font-400 '>{adharNumber}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4 py-2">Email: <span className='fs-3 base-font-400 '>{email}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4 py-2">Area: <span className='fs-3 base-font-400 '>{area}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4 py-2">Address: <span className='fs-3 base-font-400 '>{address}</span> </h5>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
};


export default ViewPropertyCards